import { render, staticRenderFns } from "./message-box.vue?vue&type=template&id=0ff9befc"
import script from "./message-box.vue?vue&type=script&lang=ts"
export * from "./message-box.vue?vue&type=script&lang=ts"
import style0 from "./message-box.vue?vue&type=style&index=0&id=0ff9befc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports